
import { errManager, mbtoa } from '@/core/config/Tools';
import GlobalService from '@/core/services/GlobalService';
import { defineComponent, ref } from 'vue';
import axios from "axios";
import moment from 'moment';

export default defineComponent({
    props: {
        evento: {
            type: Object,
            required: true,
            default: {}
        },
        sport: {
            type: Object,
            required: true,
            default: {}
        },
        listStatus: {
            type: null,
            required: true,
            default: []
        },
        rowClub: {
            type: null,
            required: true,
            default: null
        }
    },
    setup(props, { emit }) {
        const loading = ref(false);
        const titleDialog = ref('');
        const isModalVisible = ref(false);
        const optionList = ref('1');
        const selectedEvents = ref<any[]>([]);
        const listEvents = ref<any[]>([]);
        const listChecks = ref<any>([]);
        let fURL;

        const onOpen = () => {
            titleDialog.value = 'Descargar CheckList';
            if (listChecks.value.length == 0) {
                listChecks.value.length = 0
                props.listStatus.forEach((element: any) => {
                    listChecks.value.push(element.id)
                });
            }
        };

        const openModal = () => {
            isModalVisible.value = true;
        };

        const changeOption = () => {
            if(optionList.value == '2'){
                getEvents();
            }
        }

        const getEvents = async() =>{
            await GlobalService.post('events', {periodo: 2025, type: ""})
            .then((res)=>{
                listEvents.value = res.data
            }).catch(({response})=>{
                errManager(response);
            })
        };

        const DownloadXLSXPDF = (ext, target, payload) => {
            loading.value = true
            let params = new URLSearchParams(payload);
            axios({
                url: process.env.VUE_APP_API_URL + `/${ext}/${target}?${params}`,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                if (ext == 'zip')
                    var fileBlob = new Blob([response.data], { type: 'application/zip' });
                else
                    var fileBlob = new Blob([response.data]);

                //var nameFile = moment().format() + "." + ext;
                var contentDisposition = response.headers['content-disposition'];
                //var match = /filename="([^"]*)"/.exec(contentDisposition);
                //var nameFile = match && match[1] ? match[1] : moment().format() + "." + ext;
                let nameFile = props.sport?.acronym + '-' + props.rowClub?.abrev + '-' + 'checklist.pdf';
                if (contentDisposition) {
                    const matches = /filename="?([^"]+)"?/.exec(contentDisposition);
                    if (matches && matches[1]) {
                        nameFile = matches[1];
                    }
                }
                console.log(contentDisposition);
                console.log('dddd' + nameFile);
                if (!fURL) {
                    fURL = document.createElement('a');
                    fURL.style.display = 'none';
                    document.body.appendChild(fURL);
                }
                var fileURL = window.URL.createObjectURL(fileBlob);
                fURL.href = fileURL;
                fURL.setAttribute('download', nameFile);
                fURL.click();
                isModalVisible.value = false;
            }).catch((err) => {
                loading.value = false
                errManager(err)
            }).finally(() => {
                loading.value = false;
            });
        }

        return {
            loading,
            titleDialog,
            isModalVisible,
            optionList,
            selectedEvents,
            listEvents,
            listChecks,
            //events
            onOpen,
            openModal,
            changeOption,
            DownloadXLSXPDF,
            mbtoa
        }
        
    },
})
